import { emptyObj } from '@beef/utils';
var selectSettings = function selectSettings(state) {
  return state.settings;
};
export var selectIsChatOpen = function selectIsChatOpen(state) {
  return selectSettings(state).isChatOpen;
};
export var selectIsMenuOpen = function selectIsMenuOpen(state) {
  return selectSettings(state).isMenuOpen;
};
export var selectIsHistoryCalled = function selectIsHistoryCalled(state) {
  return selectSettings(state).isHistoryCalled;
};
export var selectIsDateBlockVisible = function selectIsDateBlockVisible(state) {
  return selectSettings(state).isDateBlockVisible;
};
export var selectChatCofig = function selectChatCofig(state) {
  return selectSettings(state).widgetConfig;
};
export var selectChatApiSettings = function selectChatApiSettings(state) {
  return selectChatCofig(state).apiSettings || emptyObj;
};
export var selectChatApiContentVersion = function selectChatApiContentVersion(state) {
  return selectChatApiSettings(state).apiContentVersion || 'V2';
};
export var selectChatApiHistoryVersion = function selectChatApiHistoryVersion(state) {
  return selectChatApiSettings(state).apiHistoryVersion || 'V5';
};
export var selectChatShowAttachmentsHydrate = function selectChatShowAttachmentsHydrate(state) {
  return selectChatApiSettings(state).isAttachmentsEnabled;
};
export var selectWindowBlocked = function selectWindowBlocked(state) {
  return selectSettings(state).windowBlocked;
};
export var selectStartButtonsConfig = function selectStartButtonsConfig(state) {
  return selectChatCofig(state).startButtonsConfig;
};
export var selectStartButtons = function selectStartButtons(state) {
  var _selectStartButtonsCo;
  return (_selectStartButtonsCo = selectStartButtonsConfig(state)) === null || _selectStartButtonsCo === void 0 ? void 0 : _selectStartButtonsCo.list;
};
export var selectAuthZoneConfig = function selectAuthZoneConfig(state) {
  return selectChatCofig(state).authZoneConfig;
};
export var selectErrorScreen = function selectErrorScreen(state) {
  return selectSettings(state).errorScreen;
};
export var selectErrorScreenType = function selectErrorScreenType(state) {
  return selectErrorScreen(state).type;
};
export var selectErrorReason = function selectErrorReason(state) {
  return selectErrorScreen(state).reason;
};
export var selectErrorRetryCount = function selectErrorRetryCount(state) {
  return selectErrorScreen(state).retryCount;
};

// WARN: Если облать из селекторов content, то появляется циклическая зависимость
var selectShowAttachmentsContent = function selectShowAttachmentsContent(state) {
  return state.content.ShowAttachments;
};
export var selectAttachmentsConfig = function selectAttachmentsConfig(state) {
  var _config$settings, _config$settings2;
  var config = selectChatCofig(state).attachmentsConfig || emptyObj;
  var isEnabled = selectShowAttachmentsContent(state) && selectChatShowAttachmentsHydrate(state);
  return {
    image: ((_config$settings = config.settings) === null || _config$settings === void 0 ? void 0 : _config$settings.find(function (i) {
      return i.type === 'Image';
    })) || emptyObj,
    file: ((_config$settings2 = config.settings) === null || _config$settings2 === void 0 ? void 0 : _config$settings2.find(function (i) {
      return i.type === 'File';
    })) || emptyObj,
    isEnabled: isEnabled
  };
};